import { type RouteRecordRaw } from 'vue-router'

import { formBuilderModuleRoutes } from '../builder/formBuilderModuleRouter'

const hestiaAwareModuleRoutes: RouteRecordRaw[] = formBuilderModuleRoutes.map(
  (route) => {
    if (
      route.name !== 'brand.website.forms' ||
      !('children' in route) ||
      !Array.isArray(route.children)
    ) {
      return route
    }

    return {
      children: route.children,
      component: async () => import('../views/FormBuilderHestiaRouteView.vue'),
      meta: route.meta,
      name: route.name,
      path: route.path,
      props: { legacyHome: false },
      redirect: route.redirect,
    }
  }
)

const formBuilderRoutes: RouteRecordRaw[] = [
  ...hestiaAwareModuleRoutes,
  {
    component: async () => import('../views/FormBuilderHestiaRouteView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'form'),
      title: 'website.forms',
    },
    name: 'brand.website.forms.home',
    path: 'forms',
    props: { legacyHome: true },
  },
]

export { formBuilderRoutes }
